import { RecipeList } from "./RecipeList";
export default RecipeList;
